






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "ui-tree"
})
export default class UiTreeComponent extends Vue {
  clickTree(value:any){
    this.$emit("clickTree",value);
  }
  
  click(){
    this.$emit("click");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tree/src/ui-tree.vue